import { RouteConfig } from "vue-router";
import { REmployerServicesBrowse } from "@/pages/Layout/views/Employer/views/Services/ServicesBrowse/REmployerServicesBrowse";
import { REmployerServicesCandidates } from "@/pages/Layout/views/Employer/views/Services/Candidates/REmployerServicesCandidates";
import { REmployerServicesInviteCandidate } from "@/pages/Layout/views/Employer/views/Services/InviteCandidate/REmployerServicesInviteCandidate";

export const REmployerServices: RouteConfig = {
  path: "services",
  component: () =>
    import(
      /* webpackChunkName: "employer-services" */
      "./VEmployerServices.vue"
    ),
  meta: {
    title: "Services",
    icon: "briefcase-outline",
    childLabel: "Job templates",
    aliasRoutes: ["cases", "employer/invite"],
  },
  children: [
    REmployerServicesBrowse,
    REmployerServicesCandidates,
    REmployerServicesInviteCandidate,
  ],
};
